/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![LightbulbIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABfklEQVR4nMWUu0oDURCGtxPRQtFW7AW1EsXawGIylwR3ZxLUYJNOfAobe4n6ACJEfQAREfQZvHQBiTYpRVTwwm40iUvcPbsJZOCH5bDn/+afcziW1e+CrLsALHvAeocsz75IboGkjKjziY3T6cIokp4g61eYgKVCVByJZZ7J5Me9LqPMmxDSG+a1MWMAsp6bmuOvSM6MzIGFYptzQ0R5MAGcJgUAS8UEUEsMIHmIBpC+JQUg62skAEmfAjfkBVm301l31nGcQdu2BwB0Bkh3PMNAgkcDgFy2b8pk3bl//0V36e8Z6EU0gGWrraMPRGeKqDCNrPutMcoBkSwiuhuBtJuRgFRqdSg4JvxRq4mON6jm7Y0ENKLrSgJAzsi8OQbWI2MAyaEVt4hkInhlOwGA5H05V5iMDfBTkJSjE8iulbQcxxlGlmMvCZDU28B1f42lYnywfSskvQ55oq96AJBqCKDaNQBYSiHPc6lrQAOiRSC9R9ZPT/43uus9Me+2vgE4drnksLnXiwAAAABJRU5ErkJggg==)
 */
export const LightbulbIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M4 8.5C4 4.36 7.58 1 12 1s8 3.36 8 7.5c0 2.64-.98 4.02-1.9 5.33-.49.7-.96 1.38-1.27 2.2C16.45 17.09 15.6 18 14.5 18h-1a.5.5 0 0 1-.5-.5v-5.77c0-.32.3-.56.6-.44.29.12.53.27.72.44a1 1 0 0 0 1.36-1.46A5.46 5.46 0 0 0 12 9c-1.3 0-2.72.37-3.68 1.27a1 1 0 1 0 1.36 1.46c.19-.17.43-.32.73-.44s.59.12.59.44v5.77a.5.5 0 0 1-.5.5h-1c-1.1 0-1.95-.92-2.33-1.96-.3-.83-.78-1.5-1.27-2.2C4.98 12.51 4 11.13 4 8.5ZM15.1 19c.5 0 .9.4.9.9 0 .7-.28 1.38-.78 1.88l-.34.34a3 3 0 0 1-2.12.88h-1.52a3 3 0 0 1-2.12-.88l-.34-.34c-.5-.5-.78-1.18-.78-1.89 0-.5.4-.89.9-.89h6.2Z"
        className={colorClass}
      />
    </svg>
  );
};
